import { memo, useEffect, useState } from "react";

import { Handle } from "reactflow";

import classnames from "classnames/bind";

import styles from "@styles/pages/flow/boxes/Box.module.scss";

import { BoxTitles } from "@boxes/BoxTitles";
import { BoxTypes } from "@boxes/BoxTypes";
import { BoxValidations } from "@boxes/BoxValidations";
import { FlowBox } from "@boxes/FlowBox";
import { Button } from "@components";
import { ForEach, If } from "@components/control-statements";
import CreativesList from "@containers/oraculo/units/CreativesList";
const css = classnames.bind(styles);

export default memo(({ data, selected, isConnectable, ...props }) => {
  const [creatives, setCreatives] = useState(data?.creatives);
  const [collapse, setCollapse] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);

  useEffect(() => {
    if (data.creatives) {
      setCreatives(creatives);
    }
  }, [data.creatives]);

  return (
    <>
      <div className={css({ selected: selected })}>
        <div
          className={css({
            inner: true,
            group: true,
            needsSetup: !BoxValidations.validate(
              BoxTypes.CreativeGroupAction,
              data
            ),
          })}
        >
          <div className={styles.header} onClick={() => setCollapse(!collapse)}>
            <div className={styles.icon}>
              <i className="far fa-layer-group" />
            </div>
            <div className="d-flex align-center justify-between flex-1">
              <div className="d-flex flex-column">
                <p className={styles.title}>{BoxTitles.CreativeGroupAction}</p>
                <If cond={data?.creatives?.length}>
                  <span className={styles.subtitle}>
                    {data?.creatives?.length} disparos aplicados
                  </span>
                </If>
              </div>
              <If cond={data?.creatives?.length}>
                <div className={css({ chevron: true, rotate: collapse })}>
                  <i className="fas fa-chevron-down" />
                </div>
              </If>
            </div>
          </div>

          {collapse && (
            <div className={styles.collapse}>
              <ul>
                <ForEach
                  items={data.creatives || []}
                  render={(creative) => (
                    <li>
                      <p>{creative.label}</p>
                      <div
                        className={styles.setup}
                        onClick={(e) => {
                          FlowBox.interceptClickAndModifyEvent(e, {
                            setup: true,
                            creativeId: creative.id,
                          });
                        }}
                      >
                        <i className="far fa-gear" />
                      </div>
                    </li>
                  )}
                />
              </ul>
            </div>
          )}

          <If cond={data?.creatives?.length}>
            <div className={styles.seeDetails}>
              <Button design="underline" onClick={() => setOpenDetails(true)}>
                <span>Ver detalhes</span>
              </Button>
            </div>
          </If>
        </div>

        <Handle
          type="target"
          position="left"
          className={styles.handleTarget}
          isConnectable={isConnectable}
        />
      </div>

      <CreativesList
        open={openDetails}
        stepId={data?.stepId}
        flowId={data?.flow_id}
        creatives={data?.creatives || []}
        onClose={() => setOpenDetails(false)}
        onDeleteCreative={(id) => {
          data.creatives = data.creatives.filter((c) => c.id != id);
          setCreatives(data.creatives);
        }}
      />
    </>
  );
});
